import * as React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material';
import { useRouter } from 'src/routes/hooks';

import { deleteProduct } from 'src/services/products.service';
import { useAuthContext } from 'src/auth/hooks';
import Iconify from '../iconify';

export default function DeleteProductDialog({ productId }) {
  const [open, setOpen] = React.useState(false);
  const router = useRouter();
  const { user } = useAuthContext();
  const clinicId = user?.clinic_id;

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const onClickDelete = async () => {
    try {
      await deleteProduct(productId, clinicId);
    } catch (error) {
      console.error('Failed to delete product:', error);
    }
    handleClose();
    router.reload();
  };

  return (
    <>
      <IconButton onClick={handleClickOpen}>
        <Iconify icon="tabler:trash" />
      </IconButton>

      <Dialog open={open} onClose={handleClose} aria-labelledby="delete-dialog-title" aria-describedby="delete-dialog-description">
        <DialogTitle id="delete-dialog-title">Delete Product</DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            Are you sure you want to delete this product?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={onClickDelete} autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
